// extracted by mini-css-extract-plugin
export default {"player":"Player_player__+G0+P"};